// Helper function to get initials from first and last name
export const getInitials = (
  firstName: string | null | undefined,
  lastName: string | null | undefined
): string => {
  const firstInitial = firstName ? firstName[0] : "";
  const lastInitial = lastName ? lastName[0] : "";
  return `${firstInitial}${lastInitial}`.toUpperCase();
};

/**
 * Adds spaces after common symbols to improve word breaking
 * @param text - The text to process
 * @returns The text with spaces added after symbols
 */
export function addSpacesAfterSymbols(text: string): string {
  if (!text) {
    return text;
  }

  // Add spaces after common symbols for better word breaking in one pass
  const regex = /([/\\|\-_+=&@#$%*()[\]{}<>;:,.!?])(?!\s)/g;
  const processedText = text.replace(regex, "$1 ");

  return processedText;
}

/**
 * Converts HTML content to plain text by removing all HTML tags
 * and converting common HTML entities to their text equivalents
 * @param html - The HTML string to convert
 * @returns The plain text content without HTML tags
 */
export function htmlToPlainText(html: string): string {
  if (!html) {
    return "";
  }

  let text = html
    .replace(/&nbsp;/g, " ")
    .replace(/&amp;/g, "&")
    .replace(/&lt;/g, "<")
    .replace(/&gt;/g, ">")
    .replace(/&quot;/g, '"')
    .replace(/&#39;/g, "'")
    .replace(/&apos;/g, "'")
    .replace(/&#(\d+);/g, (_m, dec) => String.fromCharCode(Number(dec)))
    .replace(/&#x([0-9a-fA-F]+);/g, (_m, hex) => String.fromCharCode(Number.parseInt(hex, 16)));

  text = text.replace(/<br\s*\/?>/gi, "\n");

  text = text.replace(/<\/p>/gi, "\n\n");

  text = text.replace(/<[^>]*>/g, "");

  text = text
    .replace(/(\r?\n\s*){3,}/g, "\n\n")
    .replace(/[ \t]+/g, " ")
    .trim();

  return text;
}

export const getFileExtension = (filename: string): string => {
  if (!filename || !filename.includes(".")) {
    return "";
  }
  return filename.split(".").pop()?.toLowerCase() ?? "";
};
